<h2 mat-dialog-title><strong>{{action}}</strong></h2>
<mat-dialog-content class="mat-typography" *ngIf="action != 'Delete'; else elseTemplate">
    <form #userForm="ngForm">
        <mat-form-field>
            <input type="text" matInput required id="name" name="name" [(ngModel)]="local_data.Name" placeholder="Name">
        </mat-form-field>
        <mat-form-field>
            <input type="text" matInput required id="position" name="position" [(ngModel)]="local_data.Position"
                placeholder="Position">
        </mat-form-field>
        <mat-form-field>
            <input type="text" matInput required id="email" name="email" [(ngModel)]="local_data.Email"
                placeholder="Email">
        </mat-form-field>
        <mat-form-field>
            <input type="text" matInput required id="mobile" name="mobile" [(ngModel)]="local_data.Mobile"
                placeholder="Mobile">
        </mat-form-field>
        <mat-form-field>
            <input type="date" matInput required id="doj" name="doj" [(ngModel)]="local_data.DateOfJoining"
                placeholder="Date">
        </mat-form-field>
        <mat-form-field>
            <input type="text" matInput required id="salary" name="salary" [(ngModel)]="local_data.Salary"
                placeholder="Salary">
        </mat-form-field>
        <mat-form-field>
            <input type="text" matInput required id="projects" name="projects" [(ngModel)]="local_data.Projects"
                placeholder="Projects">
        </mat-form-field>
    </form>
</mat-dialog-content>
<ng-template #elseTemplate>
    Sure to delete <b>{{local_data.title}}</b>?
</ng-template>
<div mat-dialog-actions align="end">
    <button mat-button (click)="doAction()" mat-flat-button color="warn">{{action}}</button>
    <button mat-button (click)="closeDialog()">Cancel</button>
</div>